<template>
  <div class="bg-[#000] mt-20 overflow-hidden p-10 py-20">
    <div class="container">
      <div class="grid lg:grid-cols-2 md:grid-cols-1 ms:grid-cols-1">
        <div
          class="text-container order-1 lg:order-[0] md:order-1 flex flex-col items-center lg:items-start justify-center z-10 pt-[4rem] lg:pt-0"
        >
          <h2
            class="title font-Approach font-bold text-[3.75rem] uppercase text-[#fff000] main-title lg:block hidden"
          >
            Case studies
          </h2>
          <h4
            class="slide-title text-[3.75rem] font-bold my-5 uppercase font-Approach overflow-text-dots lg:text-start text-center"
          >
            Diet &amp; Cheat
          </h4>
          <p
            class="pointer-events-none text-2xl lg:text-4xl overflow-text-dots lg:text-start text-center lg:pe-3"
          >
            Streamlined My Fitness Business Operations
          </p>
          <div class="swiper-controls my-10 w-fit md:flex hidden">
            <div
              id="prev-slide"
              class="p-2 prev-slide rounded-full shadow-xlg cursor-pointer hover:text-primary disabled:opacity-80"
            >
              <svg
                data-v-4fa0a2a1=""
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                role="img"
                class="icon"
                width="45px"
                height="45px"
                viewBox="0 0 16 16"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                ></path>
              </svg>
            </div>
            <div
              id="next-slide"
              class="p-2 next-slide rounded-full shadow-xlg cursor-pointer text-primary hover:text-primary disabled:opacity-80"
            >
              <svg
                data-v-4fa0a2a1=""
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true"
                role="img"
                class="icon"
                width="45px"
                height="45px"
                viewBox="0 0 16 16"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8L4.646 2.354a.5.5 0 0 1 0-.708z"
                ></path>
              </svg>
            </div>
          </div>
          <div class="my-4">
            <div class="w-full flex">
              <button
                class="main-btn outline-none gap-2 border-[#FFF000] text-[16px] text-black font-semibold px-5 bg-[#FFF000]"
              >
                <div
                  class="text flex items-center justify-center py-3 gap-3 text-xl"
                >
                  <span class="font-bold"> Explore now </span>
                  <div class="icon" style="transform: rotate(-45deg)">
                    <svg
                      data-v-4fa0a2a1=""
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      aria-hidden="true"
                      role="img"
                      class="icon"
                      width="22px"
                      height="22px"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="m14 18l-1.4-1.45L16.15 13H4v-2h12.15L12.6 7.45L14 6l6 6l-6 6Z"
                      ></path>
                    </svg>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <swiper
          ref="target"
          :effect="'coverflow'"
          :autoplay="false"
          :grabCursor="true"
          :centeredSlides="true"
          :slidesPerView="'auto'"
          :navigation="{
            nextEl: '.next-slide',
            prevEl: '.prev-slide',
          }"
          :direction="rtl"
          :coverflowEffect="{
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true,
          }"
          :pagination="false"
          :modules="modules"
          @slideChange="activeIndex"
          class="mySwiper"
          id="swiperWrapper"
        >
          <swiper-slide
            v-for="(card, idx) in holder"
            :key="idx"
            class="swip-slide slide-text-wrapper relative"
          >
            <div
              class="p-6 flex flex-col w-full h-full justify-between z-[9999999999] absolute h-full"
            >
              <div class="title font-Approach font-bold">0{{ idx + 1 }}</div>
              <div class="title overflow-text-dots font-bold font-Approach">
                {{ card.title }}
              </div>
            </div>
            <div
              class="w-full overflow-hidden rounded-2xl absolute top-0 left-0 right-0 bottom-0"
            ></div>
            <img
              :src="card.img"
              alt="SALAH SLEEM TEAM"
              class="object-cover h-[800px] w-full transition-all opacity-80 hover:opacity-100"
              style="object-fit: cover"
            />
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, ref, watch, reactive, toRefs } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/navigation";
import "swiper/css";
import slaahImage from "@/assets/images/pic_1.png";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import { EffectCoverflow, Pagination } from "swiper/modules";
export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    // Create a ref to hold the reference to the DOM element with a specific class
    const myElement = ref(null);
    const myElement2 = ref(null);
    const swiper = ref();
    const activeSlide = ref(0);
    const slideItems = reactive([
      {
        title: "salah selem",
        img: slaahImage,
      },
      {
        title: "salah selem",
        img: slaahImage,
      },
      {
        title: "salah selem",
        img: slaahImage,
      },
    ]);
    const attributes = ref({
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
        reverseDirection: false,
      },
      effect: {
        rotate: 0, // Slide rotate in degrees
        stretch: 0, // Stretch space between slides (in px)
        depth: 200, // Depth offset in px (slides translate in Z axis)
        modifier: 1, // Effect multiple
        slideShadows: true, // Enables slides
      },
      navigation: {
        nextEl: "#next-slide",
        prevEl: "#prev-slide",
      },
    });
    const holder = JSON.parse(JSON.stringify(slideItems));

    const init = (instance) => {
      swiper.value = instance;
    };
    const target = ref(null);
    const activeIndex = (index) => {
      activeSlide.value = index.activeIndex;
    };
    watch(activeSlide, (oldCurrentSlide, newCurrentSlide) => {
      console.log(newCurrentSlide, oldCurrentSlide);
      if (newCurrentSlide === 0) {
        myElement.value.classList.add("overflow-unset");
      } else if (newCurrentSlide === 1) {
        myElement.value.classList.remove("overflow-unset");
      }
      if ((newCurrentSlide === 2) | 3 | 4 | 5) {
        myElement.value.classList.add("overflow-unset");
      }
    });
    onMounted(() => {
      const elementWithClass = document.querySelector(".mySwiper");
      const elementWithClass2 = document.querySelector(".swiper-slide-prev");
      if (elementWithClass) {
        myElement.value = elementWithClass;
        console.log("Element Reference:", myElement.value);
      } else {
        console.warn("Element not found.");
      }
      if (elementWithClass2) {
        myElement2.value = elementWithClass;
      } else {
        console.warn("Element not found.");
      }
    });

    return {
      modules: [EffectCoverflow, Pagination],
      activeIndex,
      activeSlide,
      target,
      holder,
      attributes,
      init,
      ...toRefs(slideItems),
    };
  },
};
</script>
<style scoped lang="scss">
.overflow-unset {
  overflow: unset !important;
}
.swiper-slide-prev {
  transition-duration: 0ms;
  transform: translate3d(0px, 0px, -200px) rotateX(0deg) rotateY(0deg) scale(1) !important;
  opacity: 0.5;
  transition: all 0.2s ease-in-out;
  filter: brightness(0.3);
}
.slide-text-wrapper {
  position: relative;
  z-index: 10 !important;
  display: flex;
  min-height: 800px;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 3rem;
  line-height: 1;
}
.main-btn {
  clip-path: polygon(
    0 0,
    0 0,
    100% 0,
    100% 0,
    100% calc(100% - 15px),
    calc(100% - 15px) 100%,
    15px 100%,
    0 100%
  );
  border-style: unset;
  overflow: hidden;
  border: 1px solid #fff000;
  background: #fff000;
  transition: 0.2s all ease-in;
  &:hover {
    background: transparent;
    color: #fff000;

    clip-path: polygon(
      0 0,
      0 0,
      83% 0,
      100% 0,
      136% calc(185% - -30px),
      calc(100% - 15px) 100%,
      186px 299%,
      0 179%
    );
  }
}
</style>
